import React from 'react'
import styled, { css } from 'styled-components'
import { translations } from 'gipsy-misc'
import FaCaretLeft from 'react-icons/lib/fa/caret-left'

const Backdrop = styled.div`
  z-index: 999;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 80px;
  background-color: rgba(240, 240, 240, 0.8);
  @keyframes fadeInFromNone {
    0% {
      display: none;
      background-color: rgba(240, 240, 240, 0);
    }

    1% {
      display: block;
      background-color: rgba(240, 240, 240, 0);
    }

    100% {
      display: block;
      background-color: rgba(240, 240, 240, 0.8);
    }
  }
  animation: fadeInFromNone 0.5s ease-out;
`

const Pane = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 430px;
  max-width: 100%;
  background-color: white;
  box-shadow: 4px 0 20px 0 #dedede;
  @keyframes slide-right {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX() (0%);
    }
  }
  animation: slide-right 0.5s ease;
`

const Frame = styled.iframe`
  border: none;
  height: 100%;
  width: 100%;
  ${props =>
    props.loading &&
    css`
      opacity: 0;
    `}
`

const Loader = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @keyframes pulsate {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.7;
    }

    100% {
      opacity: 1;
    }
  }
  animation: pulsate 1s infinite;
`

export class DesktopSupportChat extends React.Component {
  state = {
    loading: true
  }
  componentDidMount = () => setTimeout(() => this.setState({ loading: false }), 3000)
  render() {
    return (
      <Backdrop onClick={this.props.onClose}>
        <Pane onClick={e => e.stopPropagation()}>
          {this.state.loading && <Loader>{translations.general.loadingSupportChat}</Loader>}
          <Frame loading={this.state.loading} src="/hubspot.html" style={{ height: '100%' }} />
        </Pane>
      </Backdrop>
    )
  }
}

const MobilePane = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: white;
  z-index: 1000;

  @keyframes fadeInFromNone {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  animation: fadeInFromNone 0.7s ease;
`

const MobileContents = styled.div`
  flex: 1;
  width: 100%;
  position: relative;
`
const CloseContainer = styled.div`
  width: 100%;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f4f4;
  border-top: 1px #e0e0e0 solid;
  color: #6f6f6f;
`

export class MobileSupportChat extends React.Component {
  state = {
    loading: true
  }
  componentDidMount = () => {
    setTimeout(() => this.setState({ loading: false }), 3000)
  }
  render() {
    return (
      <MobilePane>
        <MobileContents>
          {this.state.loading && <Loader>{translations.general.loadingSupportChat}</Loader>}
          <Frame loading={this.state.loading} src="/hubspot.html" style={{ height: '100%' }} />
        </MobileContents>
        <CloseContainer>
          <FaCaretLeft /> <span onClick={this.props.onClose}>Back to the app</span>
        </CloseContainer>
      </MobilePane>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/supportchat/index.js